import { useQuery } from '@tanstack/react-query';
import { getValuationSettings, ValuationSettings } from '../../../api/ValuationSettings/valuationSettings';

export function useGetValuationSettings() {
  const getQuery = useQuery({
    queryKey: [ 'getValuationSettings' ],
    queryFn: () => getValuationSettings()
  });

  return {
    data: (getQuery.data?.data.results as ValuationSettings) || null,
    error: getQuery.error || null,
    isLoading: getQuery.isLoading,
    refetch: getQuery.refetch
  };
}
